import styles from './style.module.scss';
import ReactDOM from 'react-dom';
import { ReactNode, useEffect } from 'react';

interface Props {
    children: ReactNode;
    title?: string;
    closeFunc?: any;
    icon?: ReactNode;
    description?: string;
    childClassName?: string;
    size: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
};

function Modal(props: Props) {
    const {
        icon,
        size,
        children,
        title,
        closeFunc,
        description,
        childClassName,
    } = props;
    const dom = document.getElementById('modal-root') as HTMLElement;

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'unset';
        }
    }, []);

    return ReactDOM.createPortal((<div className={styles.backDrop}>
        <div className={styles.container} data-modal-size={size}>
            <div className={styles.header}>
                {icon && <div className={styles.header_icon}>{icon}</div>}
                <div className={styles.header_content}>
                    <div className={styles.header_content_title}>
                        <span className={styles.text}>{title}</span>
                        {closeFunc && <span className={styles.close_icon} onClick={closeFunc}>&times;</span>}
                    </div>
                    {description && <p>{description}</p>}
                </div>
            </div>
            <div className={`${styles.child} ${childClassName || ''}`}>{children}</div>
        </div>
    </div>), dom)
};

export default Modal;
